var map = {
	"./de.json": 695,
	"./en.json": 696,
	"./es.json": 697,
	"./fr.json": 698
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;


//////////////////
// WEBPACK FOOTER
// ./modules/locale ^\.\/.*\.json$
// module id = 694
// module chunks = 0